export enum globalEvents {
  SET_CREDENTIALS = "SET-CREDENTIALS",
  USER_CLEAR = "USER-CLEAR",
  APPOINTMENT_RESCHEDULED = "APPOINTMENT-RESCHEDULED"
}
